/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateRootClientIdMax = 36;

export const mutateRootClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateRootNameMax = 100;

export const MutateRoot = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(mutateRootClientIdMax)
    .regex(mutateRootClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
    ),
  contentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  name: zod
    .string()
    .min(1)
    .max(mutateRootNameMax)
    .describe(
      'Caller’s label for this root, echoed in the response so a batch with several roots can be reattached without positional guessing.',
    ),
});

export type MutateRoot = zod.input<typeof MutateRoot>;
export type MutateRootOutput = zod.output<typeof MutateRoot>;
